<template>
  <div class="headrs">
    <div class="head_box">
      <div class="icon_logo" @click="$router.push('/')">
        <img src="../assets/head/home_logo.png">
      </div>
      <div class="nav">
        <div  @mouseover="changNav(item.cate,index)" @click="changChild(item.path,item.cate)"
             :class="{'active_nav':$route.meta.login==item.cate}" class="nav_item"
             v-for="(item,index) in navList" :key="index">{{ item.name }}
          <div  v-if="(catindex==1 || catindex==2) && outLing == item.cate" class="box_img_cut">
            <div @click.stop="changChildNav(items.path,items.cate)"
                 :class="{'active_child_nav':items.path==$route.path}" class="item_nav_box"
                 v-for="(items,indexs) in item.chid" :key="indexs">{{ items.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="head_box_wap">
      <div class="icons" @click="$router.push('/')">
        <img src="../assets/head/home_logo.png">
      </div>
      <div class="inco_icons" @click="changShow"><img src="../assets/head/wap_icon.png"></div>
    </div>
    <van-popup v-model="show" position="top" :style="{ width: '100%' }">
      <div class="wap_nav" position="top">
        <div class="fun_boxs">
          <div class="icons">
            <img src="../assets/head/home_logo.png">
          </div>
          <div @click="ColseShow" class="inco_icons"><img src="../assets/head/colse.png"></div>
        </div>
        <div class="lines_no"></div>
        <div class="box_intus">
          <div class="vant_ites" :class="{'active_item_box':item.check}" v-for="(item,index) in navList" :key="index">
            <div class="item_box" :class="{'active_nav':$route.meta.login==item.cate}" @click="changWap(item.path,index,item)" >
              <span>{{item.name}}</span> <img v-if="index==1 || index==2" src="../assets/head/top.png">
            </div>
            <div v-if="item.check" class="box_info_tax">
               <div @click.stop="changChildNavWap(items.path)" class="item_box_caser"  :class="{'active_item_box_caser':items.path==$route.path}" v-for="(items,index) in item.chid">{{items.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "Headr",
  data() {
    return {
      show: false,
      navList: [
        {
          name: '首页',
          cate: 'home',
          path: '/'
        },
        {
          name: '关于升和',
          cate: 'about',
          path: '/about',
          check:false,
          chid: [
            {
              name: '公司简介',
              path: '/about/CompanyProfile',
              cate: 'about',
            },
            {
              name: '企业历程',
              path: '/about/EnterpriseHistory',
              cate: 'about',
            },
            {
              name: '荣誉资质',
              path: '/about/qualification',
              cate: 'about',
            },
            {
              name: '文化理念',
              path: '/about/CulturalConcept',
              cate: 'about',
            },
          ]
        },
        {
          name: '产品中心',
          cate: 'product',
          path: '/product',
          check:false,
          chid: [
            {
              name: '品牌产品',
              path: '/product/brand',
              cate: 'product',
            },
            {
              name: '更多产品',
              path: '/product/moreProduct',
              cate: 'product',
            },
          ]
        },
        {
          name: '新闻中心',
          cate: 'news',
          path: '/news'
        },
        {
          name: '招贤纳士',
          cate: 'recruit',
          path: '/recruit'
        },
        {
          name: '联系我们',
          cate: 'contactUs',
          path: '/contactUs'
        },
      ],
      nav_cate: '/',
      outLing: '',
      catindex: '',
      casrteIndex: '',
    }
  },
  methods: {
    changShow(){
      this.show = true
    },
    ColseShow(){
      this.show = false
    },
    changWap(e, index,item) {
      if(index==1 || index==2){
        item.check = !item.check
      }else {
        this.$router.push(e)
        this.show = false
      }
    },
    changChildNavWap(e){
      this.$router.push(e)
      this.show = false
    },
    changNav(e, index) {
      this.outLing = e
      this.catindex = index
    },
    // changOut(e, index) {
    //   this.outLing = ''
    //   this.catindex = ''
    // },
    changChildNav(e, nav) {
      this.$router.push(e)
      this.nav_cate = nav
    },
    changChild(e, nav) {
      this.nav_cate = nav
      this.$router.push(e)
    }
  }
}
</script>

<style scoped lang="less">
.headrs {
  cursor: pointer;
  width: 100%;
  height: 100px;
  background: #FFFFFF;

  .head_box {
    width: 1200px;
    margin: 0 auto;
    height: 100px;
    display: flex;
    align-items: center;

    .icon_logo {
      width: 222px;
      height: 80px;
      margin-right: 357px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .nav {
      width: 622px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .nav_item {
        width: 74px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        font-size: 17px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        z-index: 4;
        position: relative;

        .box_img_cut {
          width: 126px;
          //padding: 22px 29px 0;
          padding-top: 22px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          z-index: 3;
          background: #FFFFFF;

          .item_nav_box {
            font-size: 17px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #555555;
            height: auto;
            line-height: 22px;
            padding-bottom: 26px;
          }

          .active_child_nav {
            color: #0092DD;
          }
        }
      }

      .active_nav {
        font-weight: bold;
        color: #0092DD;
        height: 94px;
        line-height: 98px;
        border-bottom: 6px solid #0092DD;
      }

      .nav_item:hover {
        font-weight: bold;
        color: #0092DD;
        height: 94px;
        line-height: 98px;
        border-bottom: 6px solid #0092DD;
      }
    }
  }

  .head_box_wap {
    display: none;
  }
}

@media (max-width: 1200px) {
  .headrs {
    cursor: pointer;
    width: 100%;
    height: 50px;
    background: #FFFFFF;

    .head_box {
      display: none;
    }

    .head_box_wap {
      padding: 0 15px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .icons {
        width: 111px;
        height: 40px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .inco_icons {
        width: 20px;
        height: 17px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .wap_nav {
      padding: 0 15px;
      .fun_boxs {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icons {
          width: 111px;
          height: 40px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .inco_icons {
          width: 14px;
          height: 14px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .lines_no {
        width: 100%;
        height: 0px;
        border-bottom: 1px solid #EEEEEE;
        margin-top: 21px;
      }

      .box_intus {
        .vant_ites {
          //display: flex;
          //justify-content: space-between;
          max-height: 55px;
          .item_box {
            width: 100%;
            height: 55px;
            border-bottom: 1px solid #EEEEEE;
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            display: flex;
            justify-content: space-between;
            align-items: center;
            transition: all 0.3s linear;
            position: relative;
            img {
              width: 11px;
              height: 10px;
              transition: all 0.3s linear;
            }
          }
          .active_nav{
            color: #0092DD;
            border-color: #0092DD;
          }
        }
        .active_item_box {
          max-height: 400px;

          img {
            transform: rotate(180deg);
          }

          .box_info_tax {
            width: 100%;
            background: #F3F3F3;
            .item_box_caser{
              height: 54px;
              padding: 0 16px;
              border-bottom: 1px solid #E1E1E1;
              font-size: 13px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 54px;
              color: #555555;
            }
            .active_item_box_caser{
              color: #0092DD;
            }
          }
        }
      }
    }

  }

}
</style>